import styled from 'styled-components'

export const FormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-400);
  margin-top: var(--space-400);
  height: 400px;
  overflow-y: auto;
`
